module.exports = __webpack_public_path__ + "img/9788955472530.32eb28f4.jpg";